const SKELETON_CARDS = [1, 2, 3, 4, 5, 6, 7, 8]

function CookSkeletonRecipeCard() {
  return (
    <div className="card recipe-card cook-skeleton-card" aria-hidden="true">
      <div className="saved-list-card-body-stack">
        <div className="saved-list-card-body-inner">
          <div className="cook-skeleton-band">
            <div className="recipe-card-band-top">
              <div className="cook-skeleton-line cook-skeleton-status-chip" />
              <div className="recipe-card-band-icons">
                <div className="cook-skeleton-circle cook-skeleton-circle--sm" />
                <div className="cook-skeleton-circle cook-skeleton-circle--sm" />
              </div>
            </div>
            <div className="cook-skeleton-line cook-skeleton-band-title" />
            <div className="recipe-card-band-chips">
              <div className="cook-skeleton-line cook-skeleton-band-chip" />
              <div className="cook-skeleton-line cook-skeleton-band-chip cook-skeleton-band-chip--short" />
            </div>
          </div>
          <div className="recipe-card-body">
            <div className="cook-skeleton-line cook-skeleton-desc" />
            <div className="cook-skeleton-line cook-skeleton-desc cook-skeleton-desc--short" />
            <div className="recipe-card-stats-divider" />
            <div className="cook-skeleton-line cook-skeleton-meta" />
            <div className="recipe-card-actions">
              <div className="cook-skeleton-line cook-skeleton-action-view" />
              <div className="cook-skeleton-circle cook-skeleton-action-plan" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function CookSkeletonToolbar({ isMobile }) {
  if (isMobile) {
    return (
      <div className="cook-mobile-filter-row" aria-hidden="true">
        <div className="cook-mobile-search-bar">
          <div className="cook-skeleton-line cook-skeleton-search cook-skeleton-search--mobile" />
        </div>
        <div className="cook-mobile-filter-scroll">
          <div className="cook-skeleton-line cook-skeleton-filter-pill cook-skeleton-filter-pill--wide" />
          <div className="cook-skeleton-line cook-skeleton-filter-pill" />
          <div className="cook-skeleton-line cook-skeleton-filter-pill" />
          <div className="cook-skeleton-line cook-skeleton-filter-pill cook-skeleton-filter-pill--filters" />
        </div>
      </div>
    )
  }

  return (
    <div className="cook-browse-filter-row" aria-hidden="true">
      <div className="cook-skeleton-line cook-skeleton-search" />
      <div className="cook-skeleton-line cook-skeleton-browse-tab" />
      <div className="cook-skeleton-line cook-skeleton-browse-tab cook-skeleton-browse-tab--narrow" />
      <div className="cook-browse-refine">
        <div className="cook-skeleton-line cook-skeleton-refine-label" />
        <div className="cook-skeleton-line cook-skeleton-filter-trigger" />
        <div className="cook-skeleton-line cook-skeleton-filter-trigger" />
        <div className="cook-skeleton-line cook-skeleton-filter-trigger" />
      </div>
    </div>
  )
}

function CookSkeletonSubTabs() {
  return (
    <>
      <div className="cook-skeleton-line cook-skeleton-sub-tab cook-skeleton-sub-tab--desktop cook-skeleton-sub-tab--active" aria-hidden="true" />
      <div className="cook-skeleton-line cook-skeleton-sub-tab cook-skeleton-sub-tab--desktop" aria-hidden="true" />
    </>
  )
}

export default function CookPageSkeleton({ isMobile = false, hidePageHeader = false, hideGetRecipesNav = false }) {
  return (
    <div className="cook-prototype-font-app cook-shell cook-page-skeleton" role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Loading saved recipes</span>

      {hidePageHeader ? null : (
      <header
        className={`cook-page-header${isMobile ? ' cook-page-header--mobile' : ''}`}
        aria-hidden="true"
      >
        <div className="page-intro-eyebrow-slot">
          <div className="cook-skeleton-line cook-skeleton-eyebrow" />
        </div>
        <div className="cook-skeleton-line cook-skeleton-page-title" />
      </header>
      )}

      <div className={`cook-methods-section${isMobile ? ' cook-methods-section--mobile' : ''}`}>
        {hideGetRecipesNav ? null : (
        <>
        <div className="cook-sub-tab-bar" aria-hidden="true">
          <CookSkeletonSubTabs />
        </div>

        <div className="cook-browse-panel">
          <div className="cook-browse-toolbar">
            <CookSkeletonToolbar isMobile={isMobile} />
          </div>

          <div className="saved-lists-grid saved-lists-skeleton">
            {SKELETON_CARDS.map((i) => (
              <CookSkeletonRecipeCard key={i} />
            ))}
          </div>
        </div>
        </>
        )}
      </div>
    </div>
  )
}
